module.exports = __webpack_public_path__ + "img/slippery.16746344.png";